<ion-content>
  <div class="notyfikacje" *ngIf="current">
    <div class="info-activity-container">
      <div class="image">
        <img src="{{ current.imageUrl }}">
      </div>
      <p class="title">{{ current.title }}</p>
      <div class="description">
        {{ current.description }}
      </div>
      <ion-button (click)="onClose_click()">Koniec</ion-button>
    </div>
  </div>
</ion-content>
